import React from "react";

interface TotalPriceDisplayProps {
  amount: number;
  label?: string;
  className?: string;
}

/**
 * 총 결제금액 표시 (오른쪽 정렬, 브랜드 색상)
 */
export default function TotalPriceDisplay({ amount, label = "총 금액", className = "" }: TotalPriceDisplayProps) {
  return (
    <div className={`flex items-center justify-between mt-3 pt-3 border-t border-[#F2F2F2] ${className}`}>
      <span className="text-lg text-gray-900">{label}</span>
      <span className="font-gmarket text-brand font-bold text-xl tabular-nums">
        {amount.toLocaleString()}원
      </span>
    </div>
  );
}
